import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../../services/api.service';
import { EngApiService } from '../../../../../services/eng-api.service';
import { SharedService } from '../../../../shared/shared.service';
import { CountableTimeZonePipe } from 'countable@helpers';

@Component({
    selector: 'app-partner-capital-preview',
    templateUrl: './partner-capital-preview.component.html',
    styleUrls: ['./partner-capital-preview.component.scss'],
    encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PartnerCapitalPreviewComponent implements OnInit {

    @Input() isEnabledHorizantal: boolean;
    @Input() isEnabledVertical: boolean;
    responseData: any = [];
    isRowAdded: boolean = false;
    verticalData: any = [];
    viewType: number = 0;
    engagementId: number;
    selectedEngagementObj: any;
    yearEnd: number;
    acctYear: number;
    userDetails: any;
    userLoginId: number;
    partCapitalHorizontalDetails: any;
    private previewInitialSub: Subscription;
    private previewRefreshSub: Subscription;

    constructor(
        public dialog       : MatDialog,
        private shareService: SharedService,
        private engApiService: EngApiService,
        private countableTimeZonePipe: CountableTimeZonePipe
    ) {}

    ngOnInit() {
      this.selectedEngagementObj = JSON.parse((localStorage.getItem('selectedEngagementObj')));
      let year = this.countableTimeZonePipe.transform(this.selectedEngagementObj.yearEnd, 'yyyy');
      this.yearEnd = +year;
      this.engagementId = this.selectedEngagementObj.engagementsid;
      this.acctYear = +year;
      //get the user details
      this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
      this.userLoginId = this.userDetails.useracctid;
      this.getPartnerCapitalVerticalStatement(1);
      this.getPartnerCapitalStatement(0);
      this.previewInitialSub = this.shareService.isEnableSettings.subscribe( res => {
        if(res.statementViewType == 0){
          this.getPartnerCapitalStatement(0);
        }
        else{
          this.getPartnerCapitalVerticalStatement(1);
        }
      });
      this.previewRefreshSub = this.shareService.refreshPreview.subscribe(response => {
        if(response == undefined){
          //this.getPartnerCapitalVerticalStatement(1);
          //this.getPartnerCapitalStatement(0);
        }
        else if(response == 0){
          this.getPartnerCapitalStatement(0);
        }
        else{
          this.getPartnerCapitalVerticalStatement(1);
        }
      });
    }

    getPartnerCapitalVerticalStatement(type: number){
      this.engApiService.getStatementOfPartnersCapital(this.engagementId, type).subscribe({
        next: res => {
          const data = JSON.parse(res?.data);
          if (data && data.length > 0) {
            this.verticalData = data;
          }
          else {
            this.verticalData = [];
          }

        }
      })
    }

    getPartnerCapitalStatement(type: number) {
      this.engApiService.getStatementOfPartnersCapital(this.engagementId, type).subscribe({
        next: res => {
          const data = JSON.parse(res?.data);
          if (data && data.length > 0) {
            this.partCapitalHorizontalDetails = data;
          }
        }
      })
    }

  ngOnDestroy() {
      if(this.previewRefreshSub){
        this.previewRefreshSub.unsubscribe();
      }
      if(this.previewInitialSub){
        this.previewRefreshSub.unsubscribe();
      }
    }
}
